import { IconButton, Button, Grid, FormControl, InputLabel, Select, MenuItem, TextField, makeStyles } from "@material-ui/core"
import { useDispatch } from "react-redux"
import { useEffect, useState } from "react"
import BeenhereIcon from '@material-ui/icons/Beenhere'
import { aprobarDevolucionAction, obtenerDevolucionesAceptadasAction } from "../../../ducks/devolucionesAceptadas"
import { ToastMessage } from "../../../global/ToastMessage"
import { offLoadAction, onLoadAnction } from "../../../ducks/loadDuck"
import HeaderModal from "../../../global/headerModal"
import ModalBase from "./../../../global/ModalBase"
import useApi from "./../../../hooks/useAPI"
import * as yup from "yup";
import { useFormik } from "formik"
import PickerMod from "../../../global/PickersMod"

export const FPagarItemStyle = makeStyles((theme) => ({
    textField: {
        width: "97%",
        margin: "5px",
        paddingBottom: 0,
        fontWeight: 500,
    },
    textFieldMultiLinea: {
        width: "97%",
        margin: "5px",
        paddingBottom: 0,
        fontWeight: 500,
    },
    formControl: {
        width: "97%",
        margin: "5px",
    },
    containerSpacing: {
        margin: "10px 0",
    },
    modalBotones: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
    },
    modalBotonesCenter: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: "2%"
    },
    modalBoton: {
        margin: "1px 0",
        width: "20%",
    },
    modal: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        maxWidth: "1160px",
        margin: "0 auto",
    },
    paper: {
        backgroundColor: theme.palette.background.paper,
        border: "none",
        boxShadow: theme.shadows[10],
        padding: theme.spacing(1, 2, 1),
        maxWidth: "1160px",
        minWidth: "500px",
    },
}))
const validationSchema = yup.object({
    monto: yup
        .number("Ingresa un monto")
        .positive("Monto postivo")
        .required("Monto es requerido"),
    tipoCambio: yup
        .number("Ingresa un T.C.")
        .positive("Monto postivo")
        .required("Monto es requerido"),
})
const InitialValues = {
    monto: 0,
    tipoCambio: 1
}

const ButtonAprovarDevolucion = (props) => {
    const { IdDevolucionSolicitud, MonedaPaquete } = props
    const [open, setOpen] = useState(false)
    const [tipoMoneda, setTipoMoneda] = useState(0)
    const [fechaPago, setFechaPago] = useState(new Date())
    const catalogoMoneda = useApi("Catalog/MonedaProveedor")
    const dispatch = useDispatch()
    const classes = FPagarItemStyle()
    useEffect(() =>{ 
        setTipoMoneda(MonedaPaquete)
    },[MonedaPaquete])
    const handleClose = () => {
        setOpen(false)
        formik.resetForm(InitialValues);
    }
    const formik = useFormik({
        initialValues: InitialValues,
        validationSchema: validationSchema,
        onSubmit: (values) => {
            onSend(values)
        },
    })
    const handleSelecTipoMoneda = (event) => {
        setTipoMoneda(event.target.value)
        formik.setFieldValue('tipoCambio', 1)
    }
    const onSend = (values) => {
        if (MonedaPaquete === 2 && values.tipoCambio <= 1)
        {
            ToastMessage.fire({
                icon: "warning",
                title: "El tipo de cambio no puede ser 1 cuendo la moneda son USD",
            })
            return null
        }
        const payload = {
            IdDevolucionSolicitud: IdDevolucionSolicitud,
            IdMoneda: tipoMoneda,
            Monto: values.monto,
            TipoCambio: values.tipoCambio
        }
        dispatch(onLoadAnction({ message: "" }))
        dispatch(aprobarDevolucionAction(payload)).then(Response => {
            dispatch(offLoadAction())
            if (Response?.status === 500) {
                ToastMessage.fire({
                    icon: "warning",
                    title: "Se produjo un error inesperado. Inténtelo de nuevo más tarde",
                });
                return null
            }
            if (Response?.status === 400) {
                ToastMessage.fire({
                    icon: "warning",
                    title: "Se produjo un error inesperado. Inténtelo de nuevo más tarde",
                });
                return null
            }
            dispatch(obtenerDevolucionesAceptadasAction())
            ToastMessage.fire({
                icon: "success",
                title: "Ingreso Correcto",
            })
        })
    }
    const handleClick = () => {
        setOpen(true)
    }
    return (
        <div>
            <IconButton aria-label="Descargar" onClick={handleClick} color="secondary" >
                <BeenhereIcon />
            </IconButton>
            <ModalBase classes={classes} open={open} onClose={handleClose}>
                <HeaderModal
                    handleClose={handleClose}
                    titulo="Pagar Devolución"
                />
                <form onSubmit={formik.handleSubmit}>
                    <Grid container className={classes.containerSpacing}>
                        <Grid item xs={12}>
                            <FormControl variant="outlined" className={classes.formControl}>
                                <InputLabel id="lTipoMoneda">Moneda</InputLabel>
                                <Select
                                    labelId="lTipoMoneda"
                                    id="STipoMoneda"
                                    name="tipoMoneda"
                                    value={tipoMoneda}
                                    onChange={handleSelecTipoMoneda}
                                    label="Moneda"
                                    disabled
                                >
                                    <MenuItem value="0" disabled>
                                        {"Seleccione una opción"}
                                    </MenuItem>
                                    {catalogoMoneda.map((moneda, index) => (
                                        <MenuItem key={moneda.IdMoneda} value={moneda.IdMoneda}>
                                            {`${moneda.Clave} - ${moneda.Descripcion}`}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} style={{ marginTop: "0.8rem" }}>
                            <TextField
                                required
                                id="input-Monto-TipoCambio"
                                label="T.C. Al momento del pago:"
                                type="text"
                                variant="outlined"
                                name="tipoCambio"
                                disabled={tipoMoneda !== 2 && tipoMoneda !== 3}
                                value={formik.values.tipoCambio}
                                onChange={formik.handleChange}
                                error={formik.touched.tipoCambio && Boolean(formik.errors.tipoCambio)}
                                helperText={formik.touched.tipoCambio && formik.errors.tipoCambio}
                                className={classes.textField}
                            // disabled={(Compra.paquete?.Cotizacion?.Moneda?.id_moneda !== Compra.paquete?.MonedaProveedor?.id_moneda)}
                            />
                        </Grid>
                        <Grid item xs={12} style={{ marginTop: "0.8rem" }}>
                            <TextField
                                required
                                id="input-Monto-PagoRemvolso"
                                label="Monto:"
                                type="text"
                                variant="outlined"
                                name="monto"
                                value={formik.values.monto}
                                onChange={formik.handleChange}
                                error={formik.touched.monto && Boolean(formik.errors.monto)}
                                helperText={formik.touched.monto && formik.errors.monto}
                                className={classes.textField}
                            // disabled={(Compra.paquete?.Cotizacion?.Moneda?.id_moneda !== Compra.paquete?.MonedaProveedor?.id_moneda)}
                            />
                        </Grid>
                        <Grid item xs={12} style={{ marginTop: "0.7rem" }}>
                            <PickerMod
                                label="Fecha de pago"
                                setSelectedDate={setFechaPago}
                                disableFuture={true}
                                disablePast={false}
                                selectedDate={fechaPago}
                            />
                        </Grid>
                    </Grid>
                    <Grid container className={classes.containerSpacing}>
                        <Grid item xs={12} className={classes.modalBotonesCenter}>
                            <Button
                                type="submit"
                                variant="contained"
                                color="primary"
                                className={classes.modalBoton}
                            >
                                Aprovado
                            </Button>
                            {/* <Button
                                onClick={handleCancel}
                                variant="contained"
                                className={classes.modalBoton}
                            >
                                Cancelar compra
                            </Button> */}
                        </Grid>
                    </Grid>
                </form>
            </ModalBase>
        </div>
    )
}
export default ButtonAprovarDevolucion